import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyEmptyStateAdvancedTraining = lazy(() => import('./svg-components/empty-state-advanced-training'));

const EmptyStateAdvancedTraining = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyEmptyStateAdvancedTraining {...rest} />
  </Suspense>
);

export default EmptyStateAdvancedTraining;
